module.exports = __webpack_public_path__ + "img/border_regular_hexagon.6d389852.svg";